import { useSelector } from 'react-redux';
import { selectDatacenterProxies } from 'store/slices/PricingSlice';
import ProductPricingCard from '../../ProductPricingCard';
import { selectCurrentDatacenterProxies } from 'store/slices/GeneralSlice';
import DatacenterTab from './Tab'

const DatacenterPricingCard = ({ sliderValue, onChange }) => {
    const data = useSelector(selectDatacenterProxies);
    const datacenterProxies = useSelector(selectCurrentDatacenterProxies)

    return (
        <ProductPricingCard
            data={data}
            fields={datacenterProxies}
            sliderValue={sliderValue}
            selectedTab={2}
            additionalComponent={<DatacenterTab sliderValue={sliderValue} onChange={onChange} />}
        />
    );
};

export default DatacenterPricingCard;
